module.exports = __webpack_public_path__ + "img/var_02_base3.b5fcc435.png";